class ProductBeforeVsAfter extends HTMLElement {
  constructor() {
    super()
    this.isDragging = false
    this.startX = 0
    this.currentX = 71.43
    this.activeComparison = null
    this.animationFrameId = null
  }

  connectedCallback() {
    this.initTabs()
    this.initComparison()
  }

  disconnectedCallback() {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId)
    }
  }

  // 初始化 tab 切换
  initTabs() {
    const tabButtons = this.querySelectorAll('[data-pbva-tab]')

    tabButtons.forEach(button => {
      button.addEventListener('click', e => {
        const tabName = e.target.dataset.pbvaTab
        this.switchTab(tabName)
      })
    })
  }

  // Tab 切换处理
  switchTab(tabName) {
    // 移除所有 active 状态
    this.querySelectorAll('[data-pbva-tab]').forEach(btn => {
      btn.classList.remove('is-active')
    })
    this.querySelectorAll('[data-pbva-slide]').forEach(slide => {
      slide.classList.remove('is-active')
    })

    // 添加 active 状态
    const activeTab = this.querySelector(`[data-pbva-tab="${tabName}"]`)
    activeTab.classList.add('is-active')
    this.querySelector(`[data-pbva-slide="${tabName}"]`).classList.add('is-active')
    this.updateContent(activeTab)

    // 重置滑块位置到 5/7（before 占 5/7，after 占 2/7）
    this.currentX = 71.43
    const comparison = this.querySelector(`[data-pbva-slide="${tabName}"] .product-before-vs-after__comparison`)
    if (comparison) {
      this.updateComparison(comparison)
    }
  }

  updateContent(tabButton) {
    const { pbvaHeading = '', pbvaSubheading = '', sectionId = '' } = tabButton.dataset
    const heading = document.getElementById(`${sectionId}-heading`)
    const subheading = document.getElementById(`${sectionId}-subheading`)

    if (heading) {
      const headingText = pbvaHeading.trim() || heading.dataset.pbvaHeading || ''

      heading.textContent = headingText
    }

    if (subheading) {
      const subheadingText = pbvaSubheading.trim() || subheading.dataset.pbvaSubheading || ''

      subheading.textContent = subheadingText
    }
  }

  // 初始化对比滑块
  initComparison() {
    const comparisons = this.querySelectorAll('.product-before-vs-after__comparison')

    comparisons.forEach(comparison => {
      const handle = comparison.querySelector('.product-before-vs-after__handle')
      const beforeImage = comparison.querySelector('.product-before-vs-after__image--before')
      const afterImage = comparison.querySelector('.product-before-vs-after__image--after')

      // 缓存 comparison 数据
      comparison._beforeImage = beforeImage
      comparison._handle = handle
      comparison._afterImage = afterImage

      // 只在 handle 上添加鼠标事件
      handle.addEventListener('mousedown', e => this.startDrag(e, comparison), false)

      // 只在 handle 上添加触摸事件
      handle.addEventListener('touchstart', e => this.startDrag(e, comparison), false)
    })

    // 使用事件委托处理 mousemove 和 touchmove
    document.addEventListener('mousemove', e => this.drag(e), false)
    document.addEventListener('touchmove', e => this.drag(e), false)
    document.addEventListener('mouseup', () => this.stopDrag(), false)
    document.addEventListener('touchend', () => this.stopDrag(), false)
  }

  startDrag(e, comparison) {
    // 检查事件是否来自 handle 或其内部元素（包括图标）
    const handle = comparison.querySelector('.product-before-vs-after__handle')
    const { target } = e

    // 如果点击在 handle 或其子元素上，则开始拖拽
    if (!handle.contains(target) && target !== handle) {
      return
    }

    this.isDragging = true
    this.activeComparison = comparison
    const clientX = e.type.startsWith('touch') ? e.touches[0].clientX : e.clientX
    this.startX = clientX

    // 添加拖拽状态样式
    comparison.classList.add('is-dragging')
  }

  drag(e) {
    if (!this.isDragging || !this.activeComparison) return

    // 防止默认滚动
    if (e.type.startsWith('touch')) {
      e.preventDefault()
    }

    const rect = this.activeComparison.getBoundingClientRect()
    const clientX = e.type.startsWith('touch') ? e.touches[0].clientX : e.clientX
    const deltaX = clientX - this.startX

    this.currentX += (deltaX / rect.width) * 100
    this.currentX = Math.max(0, Math.min(100, this.currentX))

    this.startX = clientX

    // 使用 requestAnimationFrame 优化性能
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId)
    }
    this.animationFrameId = requestAnimationFrame(() => {
      this.updateComparison(this.activeComparison)
    })
  }

  stopDrag() {
    if (!this.isDragging) return

    this.isDragging = false
    if (this.activeComparison) {
      this.activeComparison.classList.remove('is-dragging')
      this.activeComparison = null
    }

    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId)
      this.animationFrameId = null
    }
  }

  updateComparison(comparison) {
    const beforeImage = comparison._beforeImage
    const handle = comparison._handle

    beforeImage.style.clipPath = `inset(0 ${100 - this.currentX}% 0 0)`
    handle.style.left = `${this.currentX}%`
  }
}

customElements.define('product-before-vs-after', ProductBeforeVsAfter)
